// Storage utilities
export const getFromLocalStorage = (key) => {
  try {
    const data = localStorage.getItem(key)
    return data ? JSON.parse(data) : null
  } catch (error) {
    console.error(`Error parsing JSON from localStorage for key ${key}:`, error)
    localStorage.removeItem(key)
    return null
  }
}

export const setToLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.error(`Error setting localStorage for key ${key}:`, error)
  }
}

export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key)
}
